import script from "./AdPlaceholder.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdPlaceholder.vue?vue&type=script&setup=true&lang=ts"

import "./AdPlaceholder.vue?vue&type=style&index=0&id=37ff336a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37ff336a"]])

export default __exports__